// Coordonnées de l'atelier, partagées par toutes les pages.
// Position relevée sur la fiche Google Maps (WGS 84 / EPSG:4326).
export const ATELIER_LAT = 14.399657;
export const ATELIER_LNG = -16.9586245;

export const PHONE_DISPLAY = '+221 77 633 31 98';
export const PHONE_TEL = 'tel:+221776333198';
export const WHATSAPP_NUMBER = '221776333198';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const EMAIL = 'aliou_ngom@yahoo.fr';
export const INSTAGRAM_URL = 'https://www.instagram.com/senegalaise_deco_meuble';

export const MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=S%C3%A9n%C3%A9galaise%20D%C3%A9co%20Menuiserie&query_place_id=ChIJ2e-u_aYhwg4RrNtY3YCTcXg';
export const MAPS_EMBED_URL = `https://maps.google.com/maps?q=${ATELIER_LAT},${ATELIER_LNG}&z=16&hl=fr&output=embed`;

export const GOOGLE_RATING = '4,3';
